import React from 'react';

export const FormContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="flex justify-center min-h-[517px] md:min-h-[661px] mt-[22px] md:mt-0 flex md:items-center">
    <div className="bg-surface-base rounded-[42px] p-[22px] md:p-[32px] flex flex-col justify-center shadow-[0px_4px_10px_rgba(42,60,68,0.08)]  max-w-[345px] md:max-w-[456px] ">
      {children}
    </div>
  </div>
);
